export enum EntryFormFieldName {
  MainBusinessPhone = 'Main Business Phone',
  BusinessName = 'Business Name or DBA',
  MainContactFirstName = 'Main Contact First Name',
  MainContactLastName = 'Main Contact Last Name',
  MainContactEmail = 'Main Contact Email',
  MainContactPhone = 'Main Contact Phone',
  MainContactPosition = 'Main Contact Position',
  IsMainContactOwner = 'Is the Main Contact an Owner of the company?',
  Street = 'Street',
  City = 'City',
  State = 'State',
  ZipCode = 'ZipCode',
  FullConsent = 'FullConsent',
  FullConsentAt = 'FullConsentAt',
}

export enum IsMainContactOwnerOption {
  Yes = 'Yes',
  No = 'No',
}
